import { memo } from "react";
import { BzModal, BzModalBody } from "../components";
import { Row, Container } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { handleModal } from "../redux/actions/modals";

const EdisAuthenticationModal = () => {

    const dispatch = useDispatch();
    const { modals } = useSelector(state => state.modals);

    const handleClose = () => {
        dispatch(handleModal([{ "EDIS_AUTHENTICATION_MODAL": false }]));
    };

    return (
        <BzModal size='sm' show={modals['EDIS_AUTHENTICATION_MODAL']} onHide={handleClose} centered className='p-3'>
            {/* <BzModalHeader>
                <Container fluid className='p-0 py-4'>
                    <Row className='g-0'>
                        <Col md={1}>
                            <BsFileLock2Fill className='d-flex justify-content-start align-self-start' size="35px" />
                        </Col>
                        <Col md={10} className='d-flex justify-content-start align-self-start'>
                            <BzHeading className='font-medium font-size10 color-text'>eDIS Authentication</BzHeading>
                        </Col>
                        <Col md={1}>
                            <GrClose size="20px" className='d-flex justify-content-end align-self-start' onClick={handleClose} />
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader> */}

            <BzModalBody>
                <Container>
                    <Row>
                        {/* <Col md={7}>
                            You have to authorise the stocks in your holdings to complete the sell transactions
                            for the day. Failing to do so will cause in transaction failure.Learn More
                        </Col>
                        <Col md={5}>
                            <BzButton className='p-2 m-2'>Authenticate</BzButton>
                            <BzButton className='p-2 m-2' onClick={handleClose}>Skip for now</BzButton>
                        </Col> */}
                        <div className='font-regular font-size2 color-text'>Give eDIS permission for Scrip(s)</div>
                    </Row>
                </Container>
            </BzModalBody>
            {/* <BzModalFooter>
                <Container fluid className='p-0 py-2'>
                    <Row className='d-flex justify-content-end align-self-start'>
                        You can access this later via Profile &gt Settings &gt eDIS authentication OR Portfolio
                    </Row>
                </Container>
            </BzModalFooter> */}
        </BzModal>

    );

};

export default memo(EdisAuthenticationModal);